import React from 'react';

import { getPatientIntegrationsAthena } from 'common-src/models/PatientIntegrationsAthena';

import useCustomSelector from 'src/hooks/useCustomSelector';

import { athenaUrl } from '../../helpers';
import styles from './AthenaLink.module.scss';

const AthenaLink = ({ patient, patientId, integration }) => {
  const resolvedPatientId = patient?.id ?? patient?.patientId ?? patientId;
  const integrations = useCustomSelector((state) =>
    resolvedPatientId ? getPatientIntegrationsAthena(state, resolvedPatientId) : [],
  );
  const resolvedIntegration = integration ?? integrations[0] ?? null;
  const athenaPatientId = resolvedIntegration?.athenaPatientId;
  const href = athenaUrl(athenaPatientId, resolvedIntegration?.practiceId);
  const hasLink = Boolean(href);
  const displayId = athenaPatientId ?? '—';

  return (
    <a
      className={`${styles.link} ${hasLink ? '' : styles.disabled}`}
      href={href}
      target={hasLink ? '_blank' : undefined}
      rel={hasLink ? 'noopener noreferrer' : undefined}
      aria-disabled={!hasLink}
      onClick={(e) => {
        if (!hasLink) e.preventDefault();
      }}
    >
      <div className={styles.badge}>
        <span className={styles.badgeText}>A</span>
      </div>
      <div className={styles.meta}>
        <span className={styles.title}>Open in Athena</span>
        <span className={styles.mrn}>{displayId}</span>
      </div>
      <span className={styles.arrow} aria-hidden="true">
        ↗
      </span>
    </a>
  );
};

export default AthenaLink;
